import { render, staticRenderFns } from "./test-content.vue?vue&type=template&id=11c6e48d&scoped=true&"
import script from "./test-content.vue?vue&type=script&lang=js&"
export * from "./test-content.vue?vue&type=script&lang=js&"
import style0 from "./test-content.vue?vue&type=style&index=0&id=11c6e48d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c6e48d",
  null
  
)

export default component.exports